// Card for showing different product on main screen of productCatalog as card list

// Library Utilities
import React from "react";

// Styles
import Styles from "./serviceCard.module.scss";
import { ACCENTCOLOR } from "../../../../Shared/colors";

// Constants
import DocsSVG from "../../../../Shared/svg/docsSVG";

// Components
import Tooltip from "../../../../Shared/tooltip/tooltip";
import Loading from "../../../../Shared/loading/loading";

// Functions
import { buttonStyles, StyledButton } from "../../../../Shared/button/button";
import Chip from "../../../../Shared/chip/chip";
import { PRODUCT_SUBSCRIPTION_STATUS } from "../../../../constants/product";
import {
  productPID,
  productName,
  productDocsHref,
  isAutoApprovedProduct,
} from "../../../../utils/dashboardMappers";

function ServiceCard({ productDetails, click, isLoading }: any) {
  const productId = productPID(productDetails);
  const displayName = productName(productDetails);
  function handleSubscribeService() {
    click("subscribe");
    return;
  }
  function handleUnsubscribeService() {
    click("unsubscribe");
    return;
  }
  return (
    <section className="position-relative" style={{ height: "100%" }}>
      {isLoading.isLoading && isLoading.serviceName === displayName ? (
        <div
          className={`d-flex align-items-center justify-content-center ${Styles.loadingCard}`}
        >
          <Loading loadingColor={ACCENTCOLOR} />
        </div>
      ) : (
        <article
          style={{
            // display: "flex",
            // flexDirection: "column",
            // backgroundColor: "white",
            // position: "relative",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            // maxHeight: "400px",
            minHeight: "260px",
            height: "100%",
          }}
          className={`${Styles.card} ${Styles.cardAnimation}`}
        >
          <header className="d-flex align-items-center p-3">
            <h2 style={{ fontSize: "20px" }} className="mb-0 px-2 fw-semibold">
              {displayName}
            </h2>

            {productDetails?.subscription_status?.toUpperCase() ===
              PRODUCT_SUBSCRIPTION_STATUS.SUBSCRIBED && (
              <div className="px-2 ml-auto">
                <Tooltip placement="bottom" title="View Docs">
                  <button
                    id="product-catalog-view-docs"
                    onClick={(e) => {
                      e.preventDefault();
                      const href = productDocsHref(productDetails);
                      if (href) {
                        window.location.href = href;
                      }
                    }}
                    style={{
                      background: "transparent",
                      outline: "none",
                      border: "none",
                    }}
                  >
                    <DocsSVG classes={Styles.SVGcolor} />
                  </button>
                </Tooltip>
              </div>
            )}
          </header>

          <section className="p-3">
            <div
              className={`${Styles.cardFooter} pb-2 pt-1 d-flex align-items-center`}
            >
              <aside className="pr-2">
                {productDetails?.subscription_status?.toUpperCase() ===
                PRODUCT_SUBSCRIPTION_STATUS.SUBSCRIBED ? (
                  // <div className="d-flex align-items-center px-2 gap-2">
                  //   <p className={`mb-0 ${Styles.trialTransactionText}`}>
                  //     Trial Transactions:
                  //   </p>
                  //   <p className={`mb-0 ${Styles.transactionCount}`}>
                  //     {productDetails.default_free_transactions}
                  //   </p>
                  // </div>
                  <></>
                ) : (
                  <>
                    {!isAutoApprovedProduct(productDetails) &&
                    productDetails?.subscription_status?.toUpperCase() !==
                      PRODUCT_SUBSCRIPTION_STATUS.SUBSCRIBED ? (
                      <div>
                        {/* <span className="pl-2 pr-1">
                      <span
                        className={`${Styles.circle} bg-strong-orange-color`}
                      ></span>
                    </span>
                    <span className="">
                      <p className={`mb-0 ${Styles.approvalRequired}`}>
                        Requires Approval
                      </p>
                    </span> */}

                        {/* <Chip message={" Requires Approval"} type="error" /> */}
                      </div>
                    ) : (
                      <div>
                        {/* <span className="pl-2 pr-1">
                      <span
                        className={Styles.circle}
                        style={{ backgroundColor: SUCCESS }}
                      ></span>
                    </span>
                    <span className="pr-3 pl-1">
                      <p className={`mb-0 ${Styles.preApproved}`}>
                        Pre-Approved
                      </p>
                    </span> */}

                        <Chip message={"Pre-Approved"} type="processing" />
                      </div>
                    )}
                  </>
                )}
              </aside>
            </div>

            <section className="py-2 px-2" style={{ height: "90px" }}>
              <p className={`mb-0 ${Styles.serviceDescription}`}>
                {productDetails.short_description}
              </p>
            </section>

            <footer
              className="d-flex align-items-center justify-content-between fixed-bottom position-absolute"
              style={{
                bottom: "12px",
                right: "10px",
                left: "10px",
                zIndex: 1,
              }}
            >
              {productDetails?.subscription_status?.toUpperCase() ===
                PRODUCT_SUBSCRIPTION_STATUS.SUBSCRIBED && (
                <div className="d-flex align-content-end justify-content-end w-100">
                  <StyledButton
                    disabled={isLoading.isLoading}
                    id={`product-catalog-unsubscribe-${productId}`}
                    onClick={handleUnsubscribeService}
                    style={{ ...buttonStyles.borderDark.normal }}
                    hoverStyle={{ ...buttonStyles.borderDark.hover }}
                  >
                    Unsubscribe
                  </StyledButton>
                </div>
              )}

              {(productDetails?.subscription_status?.toUpperCase() ===
                PRODUCT_SUBSCRIPTION_STATUS.UNSUBSCRIBED ||
                productDetails?.subscription_status?.toUpperCase() ===
                  PRODUCT_SUBSCRIPTION_STATUS.REJECTED) && (
                <div className="d-flex align-content-end justify-content-end w-100">
                  <StyledButton
                    disabled={isLoading.isLoading}
                    id={`product-catalog-subscribe-${productId}`}
                    onClick={handleSubscribeService}
                    style={{ ...buttonStyles.primary.normal }}
                    hoverStyle={{ ...buttonStyles.primary.hover }}
                  >
                    Subscribe
                  </StyledButton>
                </div>
              )}

              {productDetails?.subscription_status?.toUpperCase() ===
                PRODUCT_SUBSCRIPTION_STATUS.PENDING_APPROVAL && (
                <div className="d-flex align-content-end justify-content-end w-100">
                  <Chip message={" Approval Pending"} type="error" />
                </div>
              )}
            </footer>
          </section>
        </article>
      )}
    </section>
  );
}

export default ServiceCard;
